<template>
  <section class="request-access" data-test="request-access">
    <h1 class="request-access__heading">{{ $t('requestAccess.title') }}</h1>
    <slot />
    <p class="request-access__body">{{ $t('requestAccess.body') }}</p>
    <a :href="contactUrl" class="request-access__cta" rel="noopener" data-test="request-access-cta">
      {{ $t('requestAccess.cta') }}
      <span aria-hidden="true" class="request-access__arrow">↗</span>
    </a>
    <p class="request-access__footer">
      {{ $t('requestAccess.haveAccount') }}
      <router-link to="/signin" class="request-access__link">{{ $t('requestAccess.signIn') }}</router-link>
    </p>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { CONTACT_URL } from '@/utils/contact';

/**
 * Lo que ve quien llega al alta sin una invitación válida: el registro es solo
 * por invitación (punto 10), así que se le explica y se le lleva a contacto.
 * El hueco (`<slot>`) es para el aviso de una invitación muerta.
 */
export default defineComponent({
  name: 'RequestAccess',
  data() {
    return { contactUrl: CONTACT_URL };
  },
});
</script>

<style scoped>
.request-access__heading {
  margin: 0 0 var(--casa-espacio-3);
  font-family: inherit;
  font-size: 40px;
  line-height: 1.0;
  font-weight: 500;
  letter-spacing: -0.04em;
  color: var(--ii-ink);
  text-wrap: balance;
}
@media (min-width: 768px) {
  .request-access__heading { font-size: 48px; }
}
@media (max-width: 480px) {
  .request-access__heading { font-size: 36px; }
}
.request-access__body {
  margin: 0 0 var(--casa-espacio-6);
  font-size: var(--casa-letra-seccion);
  line-height: 1.5;
  color: var(--ii-ink-2);
  text-wrap: balance;
}
.request-access__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--casa-espacio-1-5);
  width: 100%;
  height: 46px;
  background: var(--ii-accent);
  color: var(--casa-texto-inverso);
  font-size: var(--casa-letra-cuerpo);
  font-weight: 400;
  border-radius: var(--casa-radio-tarjeta);
  text-decoration: none;
  transition: background .15s;
}
.request-access__cta:hover { background: var(--ii-accent-2); }
.request-access__arrow { display: inline-block; transform: translateY(-1px); }
.request-access__footer {
  margin-top: var(--casa-espacio-8);
  font-size: var(--casa-letra-texto);
  color: var(--ii-ink-2);
  line-height: 1.5;
}
.request-access__link {
  color: var(--ii-ink);
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
